module.exports = __webpack_public_path__ + "img/Butterfly_00145.22e4af69.png";